export default "__VITE_ASSET__CPbsZ0RI__"